import { DOCX_FILE_TYPE, downloadFile } from "../../../helper/downloadFileHelper";
import viagsApiDev from "../../../pages/chats/api/axiosClientdev";
import { IVosResponse } from "../../vosClient";

export interface ProcessLeaveRequestPayload {
  id: number;
  email: string;

  RequestStatus: string;
  VAppId: number;
  Reason: string;
  Step: number;
  VRegID: number;
}

export interface ProcessLeaveRequestResponse {
  vAppId: number;
}

export interface IDownloadLeaveRequestTemplateParams {
  id: number;
}

export class LeaveRequestService {
  static async processLeaveRequest({
    id,
    email,
    ...payload
  }: ProcessLeaveRequestPayload): Promise<IVosResponse<unknown>> {
    const response = await viagsApiDev.patch<IVosResponse<ProcessLeaveRequestResponse>>(
      `/api/vos/updatestatus_vos/${id}`,
      payload,
      {
        params: {
          userEmail: email,
        },
      },
    );

    return response.data;
  }

  static async downloadLeaveRequestTemplate(params: IDownloadLeaveRequestTemplateParams): Promise<void> {
    await downloadFile({
      axiosClient: viagsApiDev,
      fileName: "ĐƠN XIN NGHỈ PHÉP.docx",
      fileType: DOCX_FILE_TYPE,
      method: "get",
      url: "/api/vos/export-template-application-for-leave",
      params,
    });
  }
}
